<app-basic-modal [status]="modalStatus"
                 [persistXToClose]="true"
                 [modalSize]="'lg'"
                 [title]="'No olvides llevar'" [modalName]="'do_not_forget_to_bring'">
  <article class="advertised-products-modal">

    <section class="button-wrapper text-center">
      <app-carousel *ngIf="chargeProducts"
                    [idPrefix]="'advertised-products-'"
                    [rows]="2"
                    [arrayProducts]="products"
                    [discountsLoaded]="isDiscountsLoaded"
                    [spaceDelete]="0"
                    [miniCard]="true"
                    [ifAdvertisedModal]="true"></app-carousel>
      <app-button [buttonId]="'advertised-product-checkout-redirect'"
                  [title]="'Continuar'"
                  routerLink="/checkout"
                  class="fixed-button"
                  (click)="close()"
                  [customClasses]="'main lg app-button__advertised-continue-btn fixed'"></app-button>
    </section>

  </article>
</app-basic-modal>
